import { useRef } from 'react'
import useMountEffect from './useMountEffect'
import { useAppContext } from '../contexts/AppContext'
import { ViewMode } from '@playbooks/action-cards-utils/src'

let isScrollingStarted = false
const SCROLL_MARGIN_ADJUSTMENT = 200

/**
 * This hook is responsible for scrolling a required not filled element into view when it becomes highlighted.
 */
export default function useScrollHighlightedIntoView() {
  const {
    highlightedIds,
    settings: { viewMode },
  } = useAppContext()
  const ref = useRef<HTMLDivElement>(null)

  const isFunnelView = viewMode === ViewMode.FUNNEL

  useMountEffect(() => {
    if (!ref.current || !highlightedIds.length || isScrollingStarted) return

    isScrollingStarted = true

    const container = isFunnelView
      ? ref.current.closest(`[data-separator-scope]`)
      : ref.current.closest(`[data-role="data-action-cards-sides-scroll-container"]`)

    const frame = ref.current!

    const { top } = frame.getBoundingClientRect()

    const contScrollTop = container!.scrollTop

    container?.scrollTo({ top: contScrollTop + top - SCROLL_MARGIN_ADJUSTMENT })

    const tid = setTimeout(() => (isScrollingStarted = false), 100)

    return () => {
      clearTimeout(tid)
      isScrollingStarted = false
    }
  })

  return ref
}
